// src/components/auth/OAuthCallback.tsx
import React from 'react';
import { useOAuthCallback } from '../../hooks/useOAuthCallback';
import OAuthCallbackStatus from './OAuthCallbackStatus';
import { OAuthProviderConfig } from '../../models/oauthProviderConfig';
import logger from '../../utils/logger';

import { gitHubProvider, googleProvider } from '../../config/oauthProviders';

interface OAuthCallbackProps {
  provider: OAuthProviderConfig; // Accept the provider config object
}

// This component handles the logic and UI for any OAuth provider callback
const OAuthCallback: React.FC<OAuthCallbackProps> = ({ provider }) => {
  // Use the hook with details from the provider config
  const { isLoading, errorMsg } = useOAuthCallback({
    providerName: provider.providerName,
    apiCallbackPath: provider.apiCallbackPath,
  });

  logger.info( `handling OAuthCallback for ${provider.providerName}`);
  
  // Render the status UI, passing the state and provider name
  return (
    <OAuthCallbackStatus
      isLoading={isLoading}
      errorMsg={errorMsg}
      providerName={provider.providerName}
    />
  );
};

export default OAuthCallback;

// Define the GitHub specific callback component with just one line inside
export const GitHubCallback: React.FC = () => <OAuthCallback provider={gitHubProvider} />;

// Define the Google specific callback component with just one line inside
export const GoogleCallback: React.FC = () => <OAuthCallback provider={googleProvider} />;


